import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { motion, useReducedMotion } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import { EASE_OUT_EXPO } from '../../components/AnimatedSection/AnimatedSection';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import './NotFoundPage.scss';

const NotFoundPage = () => {
    const { t } = useTranslation();
    const prefersReducedMotion = useReducedMotion();

    const fadeUp = (delay, duration = 1.0) =>
        prefersReducedMotion
            ? {}
            : {
                  initial: { opacity: 0, y: 20 },
                  whileInView: { opacity: 1, y: 0 },
                  viewport: { once: true, amount: 0.25 },
                  transition: { duration, delay, ease: EASE_OUT_EXPO },
              };

    return (
        <div className="not-found-page">
            <Helmet>
                <title>{t('seo_404_title')}</title>
            </Helmet>
            <Header />
            <section className="not-found-page__content">
                <motion.h1 className="not-found-page__code" {...fadeUp(0, 1.2)}>404</motion.h1>
                <motion.h2 className="not-found-page__title" {...fadeUp(0.12, 1.1)}>{t('not_found_title')}</motion.h2>
                <motion.p className="not-found-page__message" {...fadeUp(0.24)}>{t('not_found_message')}</motion.p>
                <motion.div {...fadeUp(0.36, 0.9)}>
                    <Link to="/" className="button button--primary">
                        {t('back_to_home')}
                    </Link>
                </motion.div>
            </section>
            <Footer />
        </div>
    );
};

export default NotFoundPage;
